angular.module('rjmNg.services').factory "chartRenderQueue", [
  "$timeout"
  ($timeout) ->
    callBackQueue = []

    _callNext = () ->
      $timeout ->
        callBackQueue.shift()()
        #if there are more callbacks call them asynchronously 
        if callBackQueue.length
          _callNext()

    (callback) ->
      callBackQueue.push(callback)
      # if there is only one callback on the queue then kick off the async calls
      if callBackQueue.length is 1
        _callNext()
]
